import {
  Autocomplete,
  Box,
  Button,
  FormControl,
  FormControlLabel,
  IconButton,
  InputAdornment,
  ListItemText,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  TextField,
  Checkbox,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { AddBox, Clear } from "@mui/icons-material";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Table from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";
import { MoneyFormatv3, NewMoneyFormatv2 } from "../../../library/MoneyFormat";
import { makeStyles } from "@mui/styles";
import CloseIcon from "@mui/icons-material/Close";
import DeleteEntries from "../../../components/modals/DeleteEntries";
import {
  showSuccessSnackbar,
  showWarningSnackbar,
} from "../../../components/snackBar/snakbar";
import CreatePriceType from "./CreatePriceType";
import { grey } from "@mui/material/colors";
import "../Components/Invoice.css";
import moment from "moment";
import { useSelector } from "react-redux";
import { MoneyTextField } from "../../../components";
const useStyles = makeStyles({
  table: {
    "& .MuiTableCell-root": {
      border: "2px solid rgba(224, 224, 224, 1)",
      borderBottom: "2px solid rgba(224, 224, 224, 1)",
    },
  },
  newTableCell: {
    "& .MuiTableCell-root": {
      borderTop: "3px solid #9b6ab7 !important", // Top border
      borderBottom: "3px solid #9b6ab7", // Bottom border
      borderLeft: "3px solid #9b6ab7", // Left border
      borderRight: "3px solid #9b6ab7", // Right border
    },
  },
  errorTableCell: {
    border: "3px solid red !important",
  },
});

function NewUpdatePriceTable({
  Type,
  tableType,
  from,
  rows,

  setRows,

  data,
  companyData,
  registrationType,
  setNewItemRowStatus,
  newItemRowStatus,
  setIsFocusItem,
  todayDate,
  deleteEntriesModal,
  setDeleteEntriesModal,
  entryIndex,
  setAmtExcGst,
  setAmtIncGst,
  amountExcGst,
  amountIncGst,
  CessTypes,
  DiscountType,
  setEffectiveToFlag,
  effectiveToFlag,
  taxableValue,
  editFlag,
  setEditFlag,
  isFocusRow,
  setIsFocusRow,
  isValid,
  setIsValid,
  PriceTypes,
  isDuplicate,
  setIsDuplicate,
  isActive,
  setIsActive,
  getCompany,
  setActiveRow,
  itemUsed,
  params,
  activeFlag,
  priceTypeArr,
  setPriceTypeArr,
  priceTypeID,
  setPriceTypeID,
  emptyPriceType,
  setEmptyPriceType,
  nameObj,
  setTableErrArr,
  newArr,
  newActiveArr,
  sellingPriceRows,
  purchasePriceRows,
  purchasePriceObj,
  sellingPriceObj,
  setDeletedRows,
}) {
  const classes = useStyles();
   const  getCompanyData = useSelector(
        (state) => state?.companyReducer?.companyDetails
      );
    
  
      const companyType = getCompanyData?.relatedcompanydetailsnew?.[0]?.registrationtype;
      const GStRates =
      (companyType === 3 && tableType==="Sales")
        ? [ 
            { id: 1, rate: "1%" },
            { id: 2, rate: "2%" },
            { id: 3, rate: "3%" },
            { id: 5, rate: "5%" },
            { id: 6, rate: "6%" },
            
          ]
        : [
            {id:-1,rate:'NIL'},
            { id: 0, rate: "0%" },
            { id: 3, rate: "3%" },
            { id: 5, rate: "5%" },
            { id: 12, rate: "12%" },
            { id: 18, rate: "18%" },
            { id: 28, rate: "28%" },
            {id:40,rate:"40%"}
          ];
  let priceandtaxHeader = [
    {
      id: "Sl.No",
      label: "Sl.No",
      minWidth: "30px",
      align: "left",
    },
    {
      id: "Active",
      label: "Set As Default",
      minWidth: "40px",
      align: "center",
    },
    {
      id: "Active",
      label: "Active",
      minWidth: "40px",
      align: "center",
    },
    {
      id: "Price Type",
      label: "Price Type",
      minWidth: "100px",
      align: "left",
      required: <span style={{ color: "#e55353", paddingLeft: "2px" }}>*</span>,
    },
    {
      id: tableType === "Sales" ? "Rate" : "Rate",
      label: tableType === "Sales" ? "Rate (₹)" : "Rate (₹)",
      minWidth: "100px",
      align: "left",
      required: <span style={{ color: "#e55353", paddingLeft: "2px" }}>*</span>,
    },
    // {
    //   id: "Discount Type",
    //   label: "Discount Type",
    //   minWidth: "100px",
    //   align: "left",
    // },
    {
      id: "Discount",
      label: "Discount",
      minWidth: "100px",
      align: "right",
    },
    {
      id: "Discount Amt (₹)",
      label: "Discount Amt (₹)",
      minWidth: "100px",
      align: "right",
    },
    {
      id: "Taxable Amt (₹)",
      label: "Taxable Amt (₹)",
      minWidth: "100px",
      align: "right",
    },
    {
      id: "GST Rate(%)",
      label: companyType === 3 && tableType === "Sales"
  ? (
      <>
        Comp.<br />
        GST(%)
      </>
    )
  : "GST Rate(%)"
,
      minWidth: "80px",
      align: "left",
      required: <span style={{ color: "#e55353", paddingLeft: "2px" }}>*</span>,
    },
    {
      id: "Cess Type",
      label: "Cess Type",
      minWidth: "100px",
      align: "left",
    },
    {
      id: "Cess",
      label: "Cess",
      minWidth: "100px",
      align: "right",
    },
    {
      id: "Net Amt(₹)",
      label: "Net Amt(₹)",
      minWidth: "130px",
      align: "right",
    },
    {
      id: "Effective From",
      label: "Effective From",
      minWidth: "100px",
      align: "left",
      required: <span style={{ color: "#e55353", paddingLeft: "2px" }}>*</span>,
    },
    {
      id: "Effective To",
      label: "Effective To",
      minWidth: "100px",
      align: "left",
      required: "",
    },

    {
      id: "action",
      label: "Action",
      minWidth: "70px",
      align: "center",
    },
  ];
  let nonPriceandtaxHeader = [
    {
      id: "Sl.No",
      label: "Sl.No",
      minWidth: "30px",
      align: "left",
    },
    {
      id: "Active",
      label: "Set As Default",
      minWidth: "40px",
      align: "center",
    },
    {
      id: "Active",
      label: "Active",
      minWidth: "40px",
      align: "center",
    },

    {
      id: "Price Type",
      label: "Price Type",
      minWidth: "100px",
      align: "left",
      required: <span style={{ color: "#e55353", paddingLeft: "2px" }}>*</span>,
    },
    {
      id: tableType === "Sales" ? "Rate" : "Rate",
      label: tableType === "Sales" ? "Rate (₹)" : "Rate (₹)",
      minWidth: "100px",
      align: "left",
      required: <span style={{ color: "#e55353", paddingLeft: "2px" }}>*</span>,
    },
    // {
    //   id: "Discount Type",
    //   label: "Discount Type",
    //   minWidth: "100px",
    //   align: "left",
    // },

    {
      id: "Discount",
      label: "Discount",
      minWidth: "100px",
      align: "right",
    },
    {
      id: "Discount Amt (₹)",
      label: "Discount Amt (₹)",
      minWidth: "100px",
      align: "right",
    },
    {
      id: "Taxable Amt (₹)",
      label: "Taxable Amt (₹)",
      minWidth: "100px",
      align: "right",
    },

    {
      id: "Net Amt (₹)",
      label: "Net Amt (₹)",
      minWidth: "130px",
      align: "right",
    },
    {
      id: "Effective From",
      label: "Effective From",
      minWidth: "100px",
      align: "left",
      required: <span style={{ color: "#e55353", paddingLeft: "2px" }}>*</span>,
    },
    {
      id: "Effective To",
      label: "Effective To",
      minWidth: "100px",
      align: "left",
      required: "",
    },
    {
      id: "action",
      label: "Action",
      minWidth: "70px",
      align: "center",
    },
  ];
  let priceandtaxHeaderWithoutCess = [
    {
      id: "Sl.No",
      label: "Sl.No",
      minWidth: "30px",
      align: "left",
    },
    {
      id: "Active",
      label: "Set As Default",
      minWidth: "40px",
      align: "center",
    },
    {
      id: "Active",
      label: "Active",
      minWidth: "40px",
      align: "center",
    },
    {
      id: "Price Type",
      label: "Price Type",
      minWidth: "100px",
      align: "left",
      required: <span style={{ color: "#e55353", paddingLeft: "2px" }}>*</span>,
    },
    {
      id: tableType === "Sales" ? "Rate" : "Rate",
      label: tableType === "Sales" ? "Rate (₹)" : "Rate (₹)",
      minWidth: "100px",
      align: "left",
      required: <span style={{ color: "#e55353", paddingLeft: "2px" }}>*</span>,
    },
    // {
    //   id: "Discount Type",
    //   label: "Discount Type",
    //   minWidth: "100px",
    //   align: "left",
    // },
    {
      id: "Discount",
      label: "Discount",
      minWidth: "100px",
      align: "right",
    },
    {
      id: "Discount Amt (₹)",
      label: "Discount Amt (₹)",
      minWidth: "100px",
      align: "right",
    },
    {
      id: "Taxable Amt (₹)",
      label: "Taxable Amt (₹)",
      minWidth: "100px",
      align: "right",
    },
    {
      id: "GST Rate(%)",
      label: companyType === 3 && tableType === "Sales"
      ? (
          <>
            Comp.<br />
            GST(%)
          </>
        )
      : "GST Rate(%)"
    ,
      minWidth: "80px",
      align: "left",
      required: <span style={{ color: "#e55353", paddingLeft: "2px" }}>*</span>,
    },
    {
      id: "Net Amt (₹)",
      label: "Net Amount (₹)",
      minWidth: "130px",
      align: "right",
    },
    {
      id: "Effective From",
      label: "Effective From",
      minWidth: "100px",
      align: "left",
    },
    {
      id: "Effective To",
      label: "Effective To",
      minWidth: "100px",
      align: "left",
      required: "",
    },
    {
      id: "action",
      label: "Action",
      minWidth: "90px",
      align: "center",
    },
  ];
 const userPreferenceAndFY = useSelector(
        (state) => state.userPrefrenceandReducer
      );
      const fyStartDate = moment(
        userPreferenceAndFY.financialYear.startdate * 1000
      ).format("YYYY-MM-DD");
  const [updatePriceRow, setUpdatePriceRow] = useState([]);
  const [rowIndex, setRowIndex] = useState("");
  const [openPriceModal, setOpenPriceModal] = useState(false);
  const [addEvent, setAddEvent] = useState(false);
  const [hasPriceType, setHasPriceType] = useState(false);
  const [successSnackbar, setsuccessSnakbar] = useState([]);
  const moveCursorToEnd = (event) => {
    event.target.focus();
    event?.target?.setSelectionRange(
      event?.target?.value?.length,
      event?.target?.value?.length
    );
  };
  async function formatNumbers(index, value, checkedValue) {
    let updatedTableArr = [...rows];

    updatedTableArr[index] = {
      ...updatedTableArr[index],
      [value]: (() => {
        let formattedValue = checkedValue;
        if (formattedValue === ".") {
          formattedValue = "0.00";
        }

        if (!/^-?\d*(\.\d{0,2})?$/.test(formattedValue)) {
          formattedValue = "0";
        }

        if (!isNaN(parseFloat(formattedValue))) {
          formattedValue = parseFloat(formattedValue).toFixed(2);
        }

        return formattedValue;
      })(),
    };

    setRows(updatedTableArr);
  }
  function closeChangesInRows(ind) {
    setEffectiveToFlag(false);
    setNewItemRowStatus(false);
    const hasValidPriceTypeInAnyRow = rows.some(
      (ele) => ele?.priceType?.label !== ""
    );
    setHasPriceType(hasValidPriceTypeInAnyRow);

    let arr = [...rows].filter((item, index) => {
      if (ind != index) {
        return item;
      }
    });
    if (arr.length === 1) {
      arr.map((ele) => {
        ele.isActive = 1;
        ele.activeType = 1;
      });
    }
    setRows(arr);
  }

  function saveChangesInRows(index) {
    let isvalid = true;
    let requireds = [];
    let errorArr = [];
    const hasValidPriceTypeInAnyRow = rows.some(
      (ele) => ele?.priceType?.label !== ""
    );

    setEmptyPriceType(hasValidPriceTypeInAnyRow);
    if (rows.length > 0) {
      rows.map((ele, index) => {
        if (
          ((ele?.priceType?.label !== "" ||
            ele?.amount !== "" ||
            ele?.amount !== 0) 
            // &&
            // tableType === "Sales"
            )
             ||
          ele?.amount !== "" ||
          ele?.amount !== 0
        ) {
          if (
            // hasValidPriceTypeInAnyRow &&
            ele?.priceType?.label === "" 
            // &&
            // tableType === "Sales"
          ) {
            isvalid = false;
            requireds.push("Price Type");
            errorArr.push(nameObj?.priceType + `${index}`);
          }
          if (ele?.amount == 0 || ele?.amount === "") {
            isvalid = false;
            requireds.push("Rate");
            errorArr.push(nameObj?.amount + `${index}`);
          }
          if (
            registrationType !== 1 &&
            (data?.taxability?.value === 1 ||
              data?.taxability?.value === 4 ||
              data?.taxability?.value === "")
          ) {
            if (
              ele?.gstRate?.id === "" ||
              ele?.gstRate?.id === undefined ||
              ele?.gstRate?.id === null
            ) {
              isvalid = false;
              requireds.push("GST Rate");
              errorArr.push(nameObj?.gstRate + `${index}`);
            }
          }
          if (ele?.effectiveTo === "") {
              isvalid = false;
              requireds.push("Effective From");
              errorArr.push(nameObj?.effectivefrom + `${index}`);
            }
        } else {
          isvalid = false;
        }
          if(isvalid){
                const currentFromDate = moment(ele.effectivefrom, ["DD-MM-YYYY", "YYYY-MM-DD"], true);
                const currentToDate = moment(ele.effectiveto, ["DD-MM-YYYY", "YYYY-MM-DD"], true);
        
                if (
                  ele.effectiveto &&
                  ele.effectiveto !== 0 &&
                  currentFromDate.isValid() &&
                  currentToDate.isValid() &&
                  !currentFromDate.isBefore(currentToDate) &&
                  !currentFromDate.isSame(currentToDate, "day")
                ) {
                  isvalid=false
                  showWarningSnackbar("Effective From date must be earlier than Effective To date.");
                  let element=nameObj?.effectivefrom + `${index}`;
                  const prevElement = document.getElementById(element);
                  prevElement?.focus();
                
                }
                
                if (
                  ele.effectiveto &&
                  ele.effectiveto !== 0 &&
                  currentFromDate.isValid() &&
                  currentToDate.isValid() &&
                  currentFromDate.isAfter(currentToDate) 
                ) {
                  isvalid=false
                  showWarningSnackbar("Effective To date must be later than Effective from date.");
                  let element=nameObj?.effectiveto + `${index}`;
                  const prevElement = document.getElementById(element);
                  prevElement?.focus();
                
                }
              }
      });
      requireds = [...new Set(requireds)];
      setIsValid(isvalid);

      if (isvalid) {
        let arr = [...rows];

        arr.map((ele) => {
          ele.invoiceType = tableType === "Sales" ? 1 : 2;
        });

        setRows([...arr, newArr]);
        setAddEvent(true);
        setIsFocusItem(false);
        setRowIndex("");
      } else {
        if (requireds.length > 1) {
          showWarningSnackbar(` ${requireds}` + " " + " " + "are required");
        }
        if (requireds.length === 1) {
          showWarningSnackbar(` ${requireds}` + " " + " " + "is required");
        }
        setTableErrArr(errorArr);
      }
    } else {
      setRows([newActiveArr]);
    }
  }

  function displayTotalAmountBySellingPrice(value, index) {
    const updatedTableArr = [...rows];
    if (Number(value) == 0) {
      updatedTableArr[index] = {
        ...updatedTableArr[index],
        amount: 0,
        amountIncludingGst: 0,
        amtaftdicount: 0,
        DiscountValue: 0,
        discountAmt: 0,
      };
    }
    const companyType =
      companyData?.relatedcompanydetailsnew?.[0]?.registrationtype;
    const compositeRate =
      companyData?.relatedcompanydetailsnew?.[0]?.comppercentage;
    let maxEffectiveTo = "";
    const filteredRows = updatedTableArr.filter(
      (ele) =>
        ele.priceType?.label?.toLowerCase().trim() ===
        updatedTableArr[index]?.priceType?.label?.toLowerCase().trim()
    );

    if (filteredRows.length > 0) {
      const validRows = filteredRows.filter(
        (ele) =>
          ele.effectiveto &&
          moment(ele.effectiveto, "YYYY-MM-DD", true).isValid()
      );

      if (validRows.length > 0) {
        maxEffectiveTo = validRows.reduce((max, ele) => {
          const effectiveTo = moment(ele.effectiveto);
          return effectiveTo.isAfter(max) ? effectiveTo : max;
        }, moment(validRows[0].effectiveto));
      } else {
        maxEffectiveTo = "";
      }
    }
    const newEffectiveFrom = maxEffectiveTo
      ? moment(maxEffectiveTo).add(1, "day").format("YYYY-MM-DD")
      : fyStartDate;
    let gstObj = {};
    let totalAmount = 0;
    let discountAmount = 0;
    let cessAmount = 0;
    let amountAfterDiscount = 0;
    let gstAmount = 0;
    GStRates.forEach((ele) => {
      if (ele.id === compositeRate) {
        gstObj = { id: ele?.id, rate: ele?.rate };
      }
    });
        const currentEffectiveFrom = updatedTableArr[index]?.effectivefrom;
        const isEffectiveFromInvalid =
          !currentEffectiveFrom ||
          !moment(currentEffectiveFrom, "YYYY-MM-DD", true).isValid();
    if (value !== 0 && value !== "") {
      if (companyType === 3 && tableType==="Sales") {
        updatedTableArr[index] = {
          ...updatedTableArr[index],
          gstRate: gstObj,
        };
      }
      discountAmount =
        updatedTableArr[index]?.DiscountType == 1
          ? (Number(value) * Number(updatedTableArr[index].DiscountValue)) / 100
          : Number(updatedTableArr[index]?.DiscountValue);
      amountAfterDiscount = Number(value) - Number(discountAmount);
      if (
        (data.taxability.value == 4 && tableType === "Sales") ||
        data.taxability.value == 5 ||
        data.taxability.value == 3 ||
        data.taxability.value == 2
      ) {
        cessAmount = 0;
        gstAmount = 0;
      } else {
        cessAmount =
          updatedTableArr[index].cesstype == 1
            ? (Number(amountAfterDiscount) *
                Number(updatedTableArr[index]?.cess)) /
              100
            : Number(updatedTableArr[index].cess);
            if( Number(updatedTableArr[index]?.gstRate?.id)>0){
        gstAmount =
          (Number(amountAfterDiscount) *
            Number(updatedTableArr[index]?.gstRate?.id)) /
          100;
        gstAmount = Number(gstAmount) / 2;
        gstAmount = Math.round(gstAmount * 100) / 100;
        gstAmount = gstAmount * 2;
            }
      }
      totalAmount =
        Number(value) -
        Number(discountAmount) +
        Number(gstAmount) +
        Number(cessAmount);

      updatedTableArr[index] = {
        ...updatedTableArr[index],
        amount: value,
        amountIncludingGst:tableType==="Sales" && companyType===3?amountAfterDiscount: totalAmount,
        amtaftdicount: amountAfterDiscount,
        discountAmt: discountAmount,
        // effectivefrom: newEffectiveFrom,
      };
      if (isEffectiveFromInvalid) {
        updatedTableArr[index] = {
          ...updatedTableArr[index],
          effectivefrom: newEffectiveFrom,
        };
      }
    } else {
      updatedTableArr[index] = {
        ...updatedTableArr[index],
        amount: 0,
        amountIncludingGst: 0,
        amtaftdicount: amountAfterDiscount,
        // effectivefrom: newEffectiveFrom,
      };
      if (isEffectiveFromInvalid) {
        updatedTableArr[index] = {
          ...updatedTableArr[index],
          effectivefrom: newEffectiveFrom,
        };
      }
    }
    setRows(updatedTableArr);
  }
  function displayTotalAmountBySellingDiscountType(value, index) {
    const updatedTableArr = [...rows];
    let totalAmount = 0;
    let discountAmount = 0;
    let cessAmount = 0;
    let amountAfterDiscount = 0;
    let gstAmount = 0;
    updatedTableArr[index] = {
      ...updatedTableArr[index],
      DiscountType: value,
      DiscountValue: 0, // Reset discount value
      discountAmt: 0,
    };
    discountAmount =
      value == 1
        ? (Number(updatedTableArr[index]?.amount) *
            Number(updatedTableArr[index]?.DiscountValue)) /
          100
        : Number(updatedTableArr[index]?.DiscountValue);
    amountAfterDiscount =
      Number(updatedTableArr[index]?.amount) - Number(discountAmount);
    if (
      (data.taxability.value == 4 && tableType === "Sales") ||
      data.taxability.value == 5 ||
      data.taxability.value == 3 ||
      data.taxability.value == 2
    ) {
      cessAmount = 0;
      gstAmount = 0;
    } else {
      cessAmount =
        updatedTableArr[index]?.cesstype == 1
          ? (Number(amountAfterDiscount) *
              Number(updatedTableArr[index]?.cess)) /
            100
          : Number(updatedTableArr[index]?.cess);
            if( Number(updatedTableArr[index]?.gstRate?.id)>0){
      gstAmount =
        (Number(amountAfterDiscount) *
          Number(updatedTableArr[index]?.gstRate?.id)) /
        100;
      gstAmount = Number(gstAmount) / 2;
      gstAmount = Math.round(gstAmount * 100) / 100;
      gstAmount = gstAmount * 2;
            }
    }
    totalAmount =
      Number(updatedTableArr[index]?.amount) -
      Number(discountAmount) +
      Number(gstAmount) +
      Number(cessAmount);
    updatedTableArr[index] = {
      ...updatedTableArr[index],
      DiscountType: value,
      DiscountValue: 0,
      discountAmt: discountAmount,
      // amountIncludingGst: totalAmount,
      amountIncludingGst:tableType==="Sales" && companyType===3?amountAfterDiscount: totalAmount,
      amtaftdicount: amountAfterDiscount,
    };
    setRows(updatedTableArr);
  }
  function displayTotalAmountBySellingDiscount(value, index) {
    const updatedTableArr = [...rows];
    let totalAmount = 0;
    let discountAmount = 0;
    let cessAmount = 0;
    let amountAfterDiscount = 0;
    let gstAmount = 0;
    discountAmount =
      updatedTableArr[index]?.DiscountType == 1
        ? (Number(updatedTableArr[index]?.amount) * Number(value)) / 100
        : Number(value);
    amountAfterDiscount =
      Number(updatedTableArr[index]?.amount) - Number(discountAmount);
    if (
      (data.taxability.value == 4 && tableType === "Sales") ||
      data.taxability.value == 5 ||
      data.taxability.value == 3 ||
      data.taxability.value == 2
    ) {
      cessAmount = 0;
      gstAmount = 0;
    } else {
      cessAmount =
        updatedTableArr[index]?.cesstype == 1
          ? (Number(amountAfterDiscount) *
              Number(updatedTableArr[index]?.cess)) /
            100
          : Number(updatedTableArr[index]?.cess);
            if( Number(updatedTableArr[index]?.gstRate?.id)>0){
      gstAmount =
        (Number(amountAfterDiscount) *
          Number(updatedTableArr[index]?.gstRate?.id)) /
        100;
      gstAmount = Number(gstAmount) / 2;
      gstAmount = Math.round(gstAmount * 100) / 100;
      gstAmount = gstAmount * 2;
            }
    }
    totalAmount =
      Number(updatedTableArr[index]?.amount) -
      Number(discountAmount) +
      Number(gstAmount) +
      Number(cessAmount);
    updatedTableArr[index] = {
      ...updatedTableArr[index],
      DiscountValue: value,
      discountAmt: discountAmount,
      // amountIncludingGst: totalAmount,
      amountIncludingGst:tableType==="Sales" && companyType===3?amountAfterDiscount: totalAmount,
      amtaftdicount: amountAfterDiscount,
    };
    setRows(updatedTableArr);
  }

  function displayTotalAmountByGSTRate(value, index) {
    const updatedTableArr = [...rows];
    let totalAmount = 0;
    let discountAmount = 0;
    let cessAmount = 0;
    let amountAfterDiscount = 0;
    let gstAmount = 0;
    discountAmount =
      updatedTableArr[index]?.DiscountType == 1
        ? (Number(updatedTableArr[index]?.amount) *
            Number(updatedTableArr[index]?.DiscountValue)) /
          100
        : Number(updatedTableArr[index]?.DiscountValue);
    amountAfterDiscount =
      Number(updatedTableArr[index]?.amount) - Number(discountAmount);
    if (
      (data.taxability.value == 4 && tableType === "Sales") ||
      data.taxability.value == 5 ||
      data.taxability.value == 3 ||
      data.taxability.value == 2
    ) {
      cessAmount = 0;
      gstAmount = 0;
    } else {
      cessAmount =
        updatedTableArr[index].cesstype == 1
          ? (Number(amountAfterDiscount) *
              Number(updatedTableArr[index]?.cess)) /
            100
          : Number(updatedTableArr[index]?.cess);
            if( Number(value?.id)>0){
      gstAmount = (Number(amountAfterDiscount) * Number(value?.id)) / 100;
      gstAmount = Number(gstAmount) / 2;
      gstAmount = Math.round(gstAmount * 100) / 100;
      gstAmount = gstAmount * 2;
            }
    }
    totalAmount =
      Number(updatedTableArr[index]?.amount) -
      Number(discountAmount) +
      Number(gstAmount) +
      Number(cessAmount);
    updatedTableArr[index] = {
      ...updatedTableArr[index],
      gstRate: value,
      discountAmt: discountAmount,
      // amountIncludingGst: totalAmount,
      amountIncludingGst:tableType==="Sales" && companyType===3?amountAfterDiscount: totalAmount,
      amtaftdicount: amountAfterDiscount,
    };

    setRows(updatedTableArr);
  }
  function displayTotalAmountBySellingCessType(value, index) {
    const updatedTableArr = [...rows];
    let totalAmount = 0;
    let discountAmount = 0;
    let cessAmount = 0;
    let amountAfterDiscount = 0;
    let gstAmount = 0;
    discountAmount =
      updatedTableArr[index].DiscountType == 1
        ? (Number(updatedTableArr[index]?.amount) *
            Number(updatedTableArr[index]?.DiscountValue)) /
          100
        : Number(updatedTableArr[index]?.DiscountValue);
    amountAfterDiscount =
      Number(updatedTableArr[index]?.amount) - Number(discountAmount);
    if (
      (data.taxability.value == 4 && tableType === "Sales") ||
      data.taxability.value == 5 ||
      data.taxability.value == 3 ||
      data.taxability.value == 2
    ) {
      cessAmount = 0;
      gstAmount = 0;
    } else {
      cessAmount =
        value == 1
          ? (Number(amountAfterDiscount) *
              Number(updatedTableArr[index]?.cess)) /
            100
          : Number(updatedTableArr[index]?.cess);
            if( Number(updatedTableArr[index]?.gstRate?.id)>0){
      gstAmount =
        (Number(amountAfterDiscount) *
          Number(updatedTableArr[index]?.gstRate?.id)) /
        100;
      gstAmount = Number(gstAmount) / 2;
      gstAmount = Math.round(gstAmount * 100) / 100;
      gstAmount = gstAmount * 2;
            }
    }
    totalAmount =
      Number(updatedTableArr[index]?.amount) -
      Number(discountAmount) +
      Number(gstAmount) +
      Number(cessAmount);
    updatedTableArr[index] = {
      ...updatedTableArr[index],
      cesstype: value,
      discountAmt: discountAmount,
      // amountIncludingGst: totalAmount,
      amountIncludingGst:tableType==="Sales" && companyType===3?amountAfterDiscount: totalAmount,
      amtaftdicount: amountAfterDiscount,
    };
    setRows(updatedTableArr);
  }
  function displayTotalAmountBySellingCess(value, index) {
    const updatedTableArr = [...rows];
    let totalAmount = 0;
    let discountAmount = 0;
    let cessAmount = 0;
    let amountAfterDiscount = 0;
    let gstAmount = 0;
    discountAmount =
      updatedTableArr[index].DiscountType == 1
        ? (Number(updatedTableArr[index]?.amount) *
            Number(updatedTableArr[index].DiscountValue)) /
          100
        : Number(updatedTableArr[index].DiscountValue);
    amountAfterDiscount =
      Number(updatedTableArr[index]?.amount) - Number(discountAmount);
    if (
      (data.taxability.value == 4 && tableType === "Sales") ||
      data.taxability.value == 5 ||
      data.taxability.value == 3 ||
      data.taxability.value == 2
    ) {
      cessAmount = 0;
      gstAmount = 0;
    } else {
      cessAmount =
        updatedTableArr[index]?.cesstype == 1
          ? (Number(amountAfterDiscount) * Number(value)) / 100
          : Number(value);
            if( Number(updatedTableArr[index]?.gstRate?.id)>0){
      gstAmount =
        (Number(amountAfterDiscount) *
          Number(updatedTableArr[index]?.gstRate?.id)) /
        100;
      gstAmount = Number(gstAmount) / 2;
      gstAmount = Math.round(gstAmount * 100) / 100;
      gstAmount = gstAmount * 2;
            }
    }
    totalAmount =
      Number(updatedTableArr[index]?.amount) +
      Number(cessAmount) +
      Number(gstAmount) -
      Number(discountAmount);
    updatedTableArr[index] = {
      ...updatedTableArr[index],
      cess: value,
      discountAmt: discountAmount,
      // amountIncludingGst: totalAmount,
      amountIncludingGst:tableType==="Sales" && companyType===3?amountAfterDiscount: totalAmount,
      amtaftdicount: amountAfterDiscount,
    };
    setRows(updatedTableArr);
  }
  function dispalyTotalAmounts() {
    let totAmtIncGST = 0;
    rows?.map((ele) => {
      totAmtIncGST += Number(ele?.amountIncludingGst);
    });
    setAmtExcGst(totAmtIncGST);
    setAmtIncGst(totAmtIncGST);
  }
  function setTableRowByTaxability(value) {
    let items = rows;
    let amountAfterDiscount = 0;
    let discountAmount = 0;
    let cessAmount = 0;
    let totalAmount = 0;
    let gstAmount = 0;
    let obj = {};
    let arr = [];
    if (value === 2 || value === 3 || value === 5) {
      items.map((itemEle) => {
        // if (itemEle?.new === false) {
        discountAmount =
          itemEle?.DiscountType == 1
            ? (Number(itemEle?.amount) * Number(itemEle?.DiscountValue)) / 100
            : Number(itemEle?.DiscountValue);
        amountAfterDiscount = Number(itemEle?.amount) - Number(discountAmount);

        obj = {
          id: itemEle?.id ? itemEle?.id : 0,
          amount: itemEle?.amount,
          DiscountType: itemEle?.DiscountType,
          DiscountValue: itemEle?.DiscountValue,
          gstRate: itemEle.gstRate,
          effectivefrom: moment(itemEle?.effectivefrom).format("YYYY-MM-DD"),
          effectiveto:
            itemEle?.effectiveto !== "" &&  itemEle?.effectiveto != 0
              ? moment(itemEle.effectiveto).format("YYYY-MM-DD")
              : "",
          cesstype: itemEle?.cesstype,
          cess: itemEle?.cess,
          amountIncludingGst: Number(amountAfterDiscount),
          discountAmt: Number(discountAmount),
          amtaftdicount: Number(amountAfterDiscount),
          priceType:itemEle.invoiceType==2?"":{label: itemEle?.priceType?.label,value:itemEle?.priceType?.value},
          activeType: itemEle.activeType,
          isActive: itemEle.isActive,
          invoiceType: itemEle.invoiceType,
          editable: false,
          expiredtimestamp: itemEle.expiredtimestamp
            ? itemEle?.expiredtimestamp
            : 0,
          new: false,
        };
        arr.push(obj);
        // }
      });
      setRows([...arr]);
    } else {
      items?.map((itemEle) => {
        // if (itemEle?.new === false) {
        discountAmount =
          itemEle?.DiscountType == 1
            ? (Number(itemEle?.amount) * Number(itemEle?.DiscountValue)) / 100
            : Number(itemEle?.DiscountValue);
        amountAfterDiscount = Number(itemEle?.amount) - Number(discountAmount);
        if (
          (data.taxability.value == 4 && tableType === "Sales") ||
          data.taxability.value == 5 ||
          data.taxability.value == 3 ||
          data.taxability.value == 2
        ) {
          cessAmount = 0;
          gstAmount = 0;
        } else {
          cessAmount =
            itemEle?.cesstype == 1
              ? (Number(amountAfterDiscount) * Number(itemEle?.cess)) / 100
              : Number(itemEle?.cess);
                if( Number(itemEle?.gstRate?.id)>0){
          gstAmount =
            (Number(amountAfterDiscount) * Number(itemEle?.gstRate?.id)) / 100;
                }
        }
        totalAmount =
          Number(amountAfterDiscount) + Number(cessAmount) + Number(gstAmount);
        itemEle.amountIncludingGst =tableType==="Sales" && companyType===3?Number(amountAfterDiscount): totalAmount;
        arr.push(itemEle);
        // }
      });
      setRows([...arr]);
    }
  }
  useEffect(() => {
    if (taxableValue !== "") {
      setTableRowByTaxability(taxableValue);
    }
  }, [taxableValue]);

  useEffect(() => {
    dispalyTotalAmounts();
  }, [rows]);
  const textFieldRef = useRef(null);

  const scrollToField = () => {
    const element = textFieldRef.current;
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center",
      });
    }
  };
  useEffect(() => {
    // const hasValidPriceTypeInAnyRow = rows.some(
    //   (ele) => ele?.priceType?.label !== ""
    // );
    // setHasPriceType(hasValidPriceTypeInAnyRow)
    if (addEvent) {
      const element = document.getElementById(
        nameObj?.isActive + `${rows.length - 1}`
      );
      element?.focus();
      setAddEvent(false);
    }
  }, [addEvent, rows]);
  useEffect(() => {
    if (data.salesAccount.value !== "") {
      const currentSalesIndex = sellingPriceRows.length - 1;
      const element = document.getElementById(
        sellingPriceObj?.isActive + `${sellingPriceRows.length - 1}`
      );
      element?.focus();
    } else {
      const currentPurchaseIndes = purchasePriceRows.length - 1;
      const element = document.getElementById(
        purchasePriceObj?.isActive + `${sellingPriceRows.length - 1}`
      );
      element?.focus();
    }
  }, []);
  function handleTextKeyDown(e, currentId, nextId, required, warMsg, prevID) {
    if (e.key === "Tab" && e.shiftKey) {
      e.preventDefault();
      e.stopPropagation();
      const prevElement = document.getElementById(prevID);
      prevElement?.focus();
      return;
    }

    if (e.key === "Enter" || (e.key === "Tab" && !e.shiftKey)) {
      if (required && e.target.value === "") {
        e.preventDefault();
        e.stopPropagation();
        showWarningSnackbar(warMsg);
        const currentElement = document.getElementById(currentId);
        currentElement?.focus();
      } else {
        e.preventDefault();
        e.stopPropagation();
        setTimeout(() => {
      const el = document.getElementById(nextId);
      el?.focus();
    }, 50);
      }
    }
  }

  function handleAutoCompleteKeyDown(
    e,
    currentId,
    nextId,
    required,
    warMsg,
    prevID,
    multiple
  ) {
    const activeDescendantId = e.target.getAttribute("aria-activedescendant");
    const isAutocompleteOpen =
      document.activeElement.getAttribute("aria-expanded") === "true";

    if (e.key === "Tab" && e.shiftKey) {
      e.preventDefault();
      e.stopPropagation();
      const prevElement = document.getElementById(prevID);
      prevElement?.focus();
      return;
    }

    if ((e.key === "Enter" || e.key === "Tab") && !e.shiftKey) {
      if (multiple && e.key === "Enter") {
        return; // Exit without moving focus to next field
      }

      // if (
      //   required &&
      //   (e.target.value === "" ) &&
      //   isAutocompleteOpen &&
      //   !activeDescendantId
      // ) {
      if (
        (e.key === "Enter" &&
          !activeDescendantId &&
          required &&
          e.target.value === "") ||
        (e.key === "Tab" &&
          !e.shiftKey &&
          required &&
          (e.target.value || "").trim() === "")
      ) {
        e.preventDefault();
        e.stopPropagation();
        showWarningSnackbar(warMsg);
        const currentElement = document.getElementById(currentId);
        currentElement?.focus();
      } else {
        e.preventDefault();
        e.stopPropagation();
        const nextElement = document.getElementById(nextId);
        nextElement?.focus();
      }
    }
  }
  const handleCloseEffectiveTo=(index)=>{
      const currentPriceType = rows[index]?.priceType?.label?.toLowerCase()?.trim();
              let hasSubsequentSamePriceType = false;
              for (let i = index + 1; i < rows.length; i++) {
                const subsequentPriceType = rows[i]?.priceType?.label?.toLowerCase()?.trim();
                if (subsequentPriceType === currentPriceType) {
                  hasSubsequentSamePriceType = true;
                  break;
                }
              }
              if (!hasSubsequentSamePriceType) {
                const updatedTableArr = [...rows];
                updatedTableArr[index] = {
                  ...updatedTableArr[index],
                  effectiveto: "",
                };
                setRowIndex(index);
                setRows(updatedTableArr);
              } else {
                showWarningSnackbar("Cannot clear date range for this row as there are subsequent entries with the same price type.");
              }
    };
  return (
    <>
      <Paper
        sx={{
          width: "100%",
          overflow: "hidden",
          marginBottom: "10px",
          boxShadow:
            "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
          ":hover": {
            boxShadow: "rgba(33, 35, 38, 0.1) 0px 10px 10px -10px",
          },
          transition: "all 1s ease-in-out",
          ".MuiTableCell-root": {
            padding: "0px 5px",
          },
          ".MuiTableCell-head": {
            borderBottom: "0px",
            fontWeight: "bold",
          },
        }}
      >
        <TableContainer className="custom-scrollbar" id={tableType}>
          <Table className="focusTableCellBorder">
            <TableHead
              onFocus={() => {
                setIsFocusItem(true);
              }}
              onBlur={() => setIsFocusItem(true)}
            >
              <TableRow
                sx={{
                  height: "40px",
                  borderBottom: "2px solid rgba(224, 224, 224, 1)",
                }}
                className={classes.table}
              >
                <TableCell
                  colSpan={
                    registrationType !== 1
                      ? (companyData?.relatedcompanydetailsnew?.[0] == undefined
                          ? companyData
                          : companyData?.relatedcompanydetailsnew?.[0]
                        )?.gstcompensationcessflag === 1
                        ? 16
                        : 14
                      : 13
                  }
                  sx={{
                    fontWeight: 600,
                    fontSize: "14px",
                    color: "input.label",
                  }}
                >
                  <Box>
                    <Typography
                      sx={{ fontWeight: "bolder", color: "primary.main" }}
                    >
                      {tableType === "Sales"
                        ? "Set Selling Price"
                        : "Set Purchase Price"}
                    </Typography>
                  </Box>
                </TableCell>
              </TableRow>

              <TableRow sx={{ height: "40px" }} className={classes.table}>
                {(registrationType !== 1
                  ? (companyData?.relatedcompanydetailsnew?.[0] == undefined
                      ? companyData
                      : companyData?.relatedcompanydetailsnew?.[0]
                    )?.gstcompensationcessflag === 1
                    ? priceandtaxHeader
                    : priceandtaxHeaderWithoutCess
                  : nonPriceandtaxHeader
                ).map((column) => {
                  // if (tableType === "Purchase" && column.id === "Price Type") {
                  //   column.label = "";
                  //   column.required = "";
                  // }
                  if (params?.view !== true) {
                    return (
                      <TableCell
                        key={column.id}
                        minWidth={column.minWidth}
                        align={column.align}
                        sx={{
                          fontWeight: 600,
                          fontSize: "14px",
                          color: "input.label",
                          backgroundColor: "background.tablebg",
                          position: column.id === "action" ? "sticky" : "",
                          right: column.id === "action" ? 0 : "",

                          zIndex: column.id === "action" ? 1 : 0,
                        }}
                      >
                        {column.label}{" "}
                        {column.id === "Price Type" ? (
                          <span>{column.required}</span>
                        ) : (
                          <span>{column.required}</span>
                        )}
                      </TableCell>
                    );
                  } else {
                    if (column?.id !== "action")
                      return (
                        <TableCell
                          key={column.id}
                          minWidth={column.minWidth}
                          align={column.align}
                          sx={{
                            fontWeight: 600,
                            fontSize: "14px",
                            color: "input.label",
                            backgroundColor: "background.tablebg",
                            position: column.id === "action" ? "sticky" : "",
                            right: column.id === "action" ? 0 : "",

                            zIndex: column.id === "action" ? 1 : 0,
                          }}
                        >
                          {column.label}{" "}
                          {column.id === "Price Type" ? (
                            <span>{column.required}</span>
                          ) : (
                            <span>{column.required}</span>
                          )}
                        </TableCell>
                      );
                  }
                })}
              </TableRow>
            </TableHead>

            <>
              <TableBody
                className={
                  activeFlag === 0 || params.view === true
                    ? "disable-interactions !important"
                    : "none"
                }
                onFocus={() => {
                  setIsFocusItem(true);
                }}
                onBlur={() => setIsFocusItem(false)}
              >
                {rows?.length > 0 ? (
                  rows?.map((col, index) => {
                    return (
                      <TableRow
                        sx={{ height: "40px" }}
                        className={classes.table}
                      >
                        <TableCell id="index" align="left">
                          {index + 1}
                        </TableCell>
                        <TableCell
                          // tabIndex="0"
                          sx={{ outline: "none" }}
                          align="center"
                          onKeyDown={(e) => {
                            const updatedTableArr = [...rows];
                            const currentSalesIndex =
                              sellingPriceRows.length - 1;

                            let puchaseFlag = data?.showItemInv?.some(
                              (ele) => ele.value === 1
                            )
                              ? 1
                              : 0;
                            let salesFlag = data?.showItemInv?.some(
                              (ele) => ele.value === 2
                            )
                              ? 1
                              : 0;

                            const warMsg = "";

                            const currentId = `${nameObj.isActive}${index}`;
                            const nextId = `${nameObj.activeType}${index}`;
                            const prevID =
                              tableType === "Sales"
                                ? index === 0
                                  ? ""
                                  : `${nameObj.isActive}${index - 1}`
                                : index === 0
                                ? salesFlag === 0
                                  ? ""
                                  : `${sellingPriceObj.isActive}${currentSalesIndex}`
                                : `${nameObj.isActive}${index - 1}`;
                            const required = false;

                            handleTextKeyDown(
                              e,
                              currentId,
                              nextId,
                              required,
                              warMsg,
                              prevID
                            );
                          }}
                          id={`${nameObj.isActive}${index}`}
                          name={`${nameObj.isActive}${index}`}
                        >
                          {col?.activeType === 1 && (
                            <FormControl
                              disabled={
                                params?.view === true || activeFlag === 0
                                  ? true
                                  : false
                              }
                            >
                              <RadioGroup
                                disabled={params?.view === true ? true : false}
                                aria-labelledby="demo-controlled-radio-buttons-group"
                                name="controlled-radio-buttons-group"
                              >
                                <FormControlLabel
                                  disabled={
                                    params?.view === true || activeFlag === 0
                                      ? true
                                      : false
                                  }
                                  control={<Radio size="small" />}
                                  value={index}
                                  onChange={(e) => {
                                    const value = e?.target.value;

                                    setIsActive(value);

                                    const updatedTableArr = [...rows];

                                    if (value == index) {
                                      updatedTableArr[index] = {
                                        ...updatedTableArr[index],
                                        isActive: value ? 1 : 0,
                                      };
                                    }

                                    const updatedRows = updatedTableArr.map(
                                      (row, idx) => ({
                                        ...row,
                                        isActive: idx == value ? 1 : 0,
                                      })
                                    );

                                    setRows(updatedRows);
                                  }}
                                  checked={col?.isActive}
                                />
                              </RadioGroup>
                            </FormControl>
                          )}
                        </TableCell>
                        <TableCell
                          tabIndex="0"
                          sx={{ outline: "none" }}
                          align="center"
                          onKeyDown={(e) => {
                            const warMsg = "";
                            const currentId = `${nameObj.activeType}${index}`;
                            const nextId =
                              // tableType === "Sales"
                              //   ? 
                                `${nameObj.priceType}${index}`
                                // : `${nameObj.amount}${index}`;
                            const prevID = `${nameObj.isActive}${index}`;
                            const required = false;

                            handleTextKeyDown(
                              e,
                              currentId,
                              nextId,
                              required,
                              warMsg,
                              prevID
                            );
                          }}
                          id={`${nameObj.activeType}${index}`}
                          name={nameObj?.activeType + `${index}`}
                        >
                          <Checkbox
                            disabled={
                              params?.view === true || activeFlag == 0
                                ? true
                                : false
                            }
                            sx={{
                              fontSize: "16px",
                              paddingTop: "0px",
                              paddingBottom: "0px",
                            }}
                            checked={col?.activeType}
                            onChange={(e) => {
                              const updatedTableArr = [...rows];

                              updatedTableArr[index] = {
                                ...updatedTableArr[index],
                                activeType: e?.target.checked ? 1 : 0,
                              };

                              setRows(updatedTableArr);
                            }}
                            color="primary"
                          />
                        </TableCell>

                        <TableCell
                          className={
                            col?.priceType?.label === "" &&
                            isValid === false &&
                            // tableType === "Sales"
                            //   ? //  &&
                                // emptyPriceType
                                classes?.errorTableCell
                              // : ""
                          }
                          align="left"
                        >
                          <Autocomplete
                            openOnFocus
                            disableClearable
                            autoFocus
                            className={classes.autocomplete}
                            id={`${nameObj.priceType}${index}`}
                            name={nameObj?.priceType + `${index}`}
                            options={["Add Price Type", ...priceTypeArr]}
                            value={col?.priceType}
                            placeholder={
                              tableType === "Sales"
                                ? "Ex: Wholesale"
                                : "Ex-Supplier 1"
                            }
                            disabled={
                              // tableType === "Purchase" ||
                              data?.itemName === "" ||
                              activeFlag === 0 ||
                              params?.view === true
                                ? true
                                : false
                            }
                            isOptionEqualToValue={(option, value) =>
                              option.value === value.value
                            }
                            componentsProps={{
                              popper: { style: { width: "fit-content" } },
                            }}
                            // onChange={(e, newValue) => {
                            //   let isDuplicate = false;
                            //   let invalidDate = false;
                            //   const updatedTableArr = [...rows];
                            //   const currentDate = moment(
                            //     updatedTableArr[index]?.effectiveto
                            //   );
                            //   const currentFromDate = moment(
                            //     updatedTableArr[index]?.effectivefrom
                            //   );

                            //   let maxEffectiveTo = "";
                            //   const filteredRows = updatedTableArr.filter(
                            //     (ele,ind) => ind!==index &&
                            //       ele.priceType?.label?.toLowerCase().trim() ===
                            //       newValue?.label?.toLowerCase().trim()
                            //   );

                            //   const emptyDateRow = filteredRows.find(
                            //     (row) => !row.effectiveto
                            //   );

                            //   if (emptyDateRow) {
                            //     showWarningSnackbar(
                            //       "Please set the Effective To Date for the previous Price Type before adding another entry of the same type."
                            //     );

                            //     const emptyDateRowIndex =
                            //       updatedTableArr.indexOf(emptyDateRow);
                            //     const element = document.getElementById(
                            //       nameObj.effectiveto + emptyDateRowIndex
                            //     );

                            //     if (element) {
                            //       element.focus();
                            //     }

                            //     // Reset the priceType for the current row
                            //     updatedTableArr[index] = {
                            //       ...updatedTableArr[index],
                            //       priceType: { label: "", value: 0 },
                            //     };
                            //     setActiveRow(true);
                            //     setRows(updatedTableArr);
                            //     return;
                            //   }

                            //   // If valid dates exist, find the max effectiveTo date
                            //   if (filteredRows.length > 0) {
                            //     const validRows = filteredRows.filter(
                            //       (ele) =>
                            //         ele.effectiveto &&
                            //         moment(
                            //           ele.effectiveto,
                            //           "YYYY-MM-DD",
                            //           true
                            //         ).isValid()
                            //     );

                            //     if (validRows.length > 0) {
                            //       maxEffectiveTo = validRows.reduce(
                            //         (max, ele) => {
                            //           const effectiveTo = moment(
                            //             ele.effectiveto
                            //           );
                            //           return effectiveTo.isAfter(max)
                            //             ? effectiveTo
                            //             : max;
                            //         },
                            //         moment(validRows[0].effectiveto)
                            //       );
                            //     } else {
                            //       maxEffectiveTo = "";
                            //     }
                            //   }

                            //   rows.forEach((ele, i) => {
                            //     if (i !== index && ele?.priceType?.label==newValue?.label) {
                            //       const effectiveFrom = moment(
                            //         ele.effectivefrom
                            //       );
                            //       const effectiveTo = moment(ele.effectiveto);

                            //       // Check if the current date is within the effective range
                            //       if (
                            //         currentDate.isBetween(
                            //           effectiveFrom,
                            //           effectiveTo,
                            //           null,
                            //           "[]"
                            //         ) ||
                            //         currentDate.isSame(effectiveFrom, "day") ||
                            //         currentDate.isSame(effectiveTo, "day") ||
                            //         currentFromDate.isBetween(
                            //           effectiveFrom,
                            //           effectiveTo,
                            //           null,
                            //           "[]"
                            //         ) ||
                            //         currentFromDate.isSame(
                            //           effectiveFrom,
                            //           "day"
                            //         ) ||
                            //         currentFromDate.isSame(effectiveTo, "day")
                            //       ) {
                            //         invalidDate = true;
                            //       }

                            //       // Check if effectiveFrom and effectiveTo are between currentFromDate and currentToDate
                            //       if (
                            //         effectiveFrom.isBetween(
                            //           currentFromDate,
                            //           currentDate,
                            //           null,
                            //           "[]"
                            //         ) ||
                            //         effectiveTo.isBetween(
                            //           currentFromDate,
                            //           currentDate,
                            //           null,
                            //           "[]"
                            //         ) ||
                            //         effectiveFrom.isSame(
                            //           currentFromDate,
                            //           "day"
                            //         ) ||
                            //         effectiveFrom.isSame(currentDate, "day") ||
                            //         effectiveTo.isSame(
                            //           currentFromDate,
                            //           "day"
                            //         ) ||
                            //         effectiveTo.isSame(currentDate, "day")
                            //       ) {
                            //         invalidDate = true;
                            //       }
                            //     }
                            //   });

                            //   updatedTableArr.forEach((ele, ind) => {
                            //     if (
                            //       ind !== index &&
                            //       ele.priceType?.label?.toLowerCase().trim() ===
                            //         newValue?.label?.toLowerCase().trim()
                            //     ) {
                            //       isDuplicate = true;
                            //     }
                            //   });

                            //   if (
                            //     // isDuplicate &&
                            //     invalidDate 
                            //     // &&
                            //     // tableType === "Sales"
                            //   ) {
                            //     showWarningSnackbar(
                            //       "Price Type already added with this date range"
                            //     );
                            //     const element = document.getElementById(
                            //       nameObj?.priceType + `${index}`
                            //     );
                            //     element?.focus();
                            //     updatedTableArr[index] = {
                            //       ...updatedTableArr[index],
                            //       priceType: { label: "", value: 0 }
                            //     };
                            //   } else {
                            //     const newEffectiveFrom = maxEffectiveTo
                            //       ? moment(maxEffectiveTo)
                            //           .add(1, "day")
                            //           .format("YYYY-MM-DD")
                            //       : updatedTableArr[index]?.effectivefrom === ""
                            //       ? fyStartDate
                            //       : updatedTableArr[index]?.effectivefrom;
                            //     updatedTableArr[index] = {
                            //       ...updatedTableArr[index],
                            //       priceType: newValue,
                            //       effectivefrom: newEffectiveFrom,
                            //     };
                            //   }

                            //   setRows(updatedTableArr);
                            //   setIsDuplicate(isDuplicate);
                            // }}
                              onChange={(e, newValue) => {
                              let isDuplicate = false;
                              let invalidDate = false;
                            
                              const updatedTableArr = [...rows];
                            
                              const norm = (s) => (s || "").toLowerCase().trim();
                              const sameType = (ele) => norm(ele?.priceType?.label) === norm(newValue?.label);
                            
                              const currentDate = moment(updatedTableArr[index]?.effectiveto, "YYYY-MM-DD", true);
                              const currentFromDate = moment(updatedTableArr[index]?.effectivefrom, "YYYY-MM-DD", true);
                            
                              const prevSameType = updatedTableArr.filter((ele, ind) => ind < index && sameType(ele));
                              const prevEmptyDateRow = prevSameType.find((row) => !row?.effectiveto);
                            
                              if (prevEmptyDateRow) {
                                showWarningSnackbar(
                                  "Please set the Effective To Date for the previous Price Type before adding another entry of the same type."
                                );
                            
                                const emptyDateRowIndex = updatedTableArr.indexOf(prevEmptyDateRow);
                                const element = document.getElementById(nameObj.effectiveto + emptyDateRowIndex);
                                if (element) element.focus();
                            
                              
                                updatedTableArr[index] = {
                                  ...updatedTableArr[index],
                                  priceType: { label: "", value: 0 },
                                };
                            
                                setRows(updatedTableArr);
                                setIsDuplicate(true);
                                return;
                              }
                            
                            
                              let maxEffectiveTo = null;
                              const prevWithValidTo = prevSameType.filter(
                                (ele) => ele?.effectiveto && moment(ele.effectiveto, "YYYY-MM-DD", true).isValid()
                              );
                            
                              if (prevWithValidTo.length > 0) {
                                maxEffectiveTo = prevWithValidTo.reduce((max, ele) => {
                                  const to = moment(ele.effectiveto, "YYYY-MM-DD", true);
                                  return to.isAfter(max) ? to : max;
                                }, moment(prevWithValidTo[0].effectiveto, "YYYY-MM-DD", true));
                              }
                            
                              const newEffectiveFrom = maxEffectiveTo
                                ? maxEffectiveTo.clone().add(1, "day").format("YYYY-MM-DD")
                                : !updatedTableArr[index]?.effectivefrom || updatedTableArr[index]?.effectivefrom === ""
                                  ? fyStartDate
                                  : updatedTableArr[index]?.effectivefrom;
                            
                            
                              const curFrom = moment(newEffectiveFrom, "YYYY-MM-DD", true);
                              const curTo = currentDate?.isValid() ? currentDate : curFrom;
                            
                            
                              const rangesOverlap = (aFrom, aTo, bFrom, bTo) =>
                                aFrom.isSameOrBefore(bTo, "day") && bFrom.isSameOrBefore(aTo, "day");
                            
                            
                              updatedTableArr.forEach((ele, i) => {
                                if (i === index || !sameType(ele)) return;
                            
                                const ef = moment(ele.effectivefrom, "YYYY-MM-DD", true);
                                const et = ele.effectiveto
                                  ? moment(ele.effectiveto, "YYYY-MM-DD", true)
                                  : ef; 
                            
                                if (ef.isValid() && et.isValid()) {
                                  if (rangesOverlap(curFrom, curTo, ef, et)) {
                                    invalidDate = true;
                                  }
                                }
                              });
                            
                            
                              updatedTableArr.forEach((ele, ind) => {
                                if (ind !== index && norm(ele?.priceType?.label) === norm(newValue?.label)) {
                                  isDuplicate = true;
                                }
                              });
                              if (invalidDate) {
                                showWarningSnackbar("Price Type already added with this date range");
                                const element = document.getElementById(nameObj?.priceType + `${index}`);
                                element?.focus();
                                updatedTableArr[index] = {
                                  ...updatedTableArr[index],
                                  priceType: { label: "", value: 0 },
                                };
                                setRows(updatedTableArr);
                                setIsDuplicate(true);
                                return;
                              }
                            
                              updatedTableArr[index] = {
                                ...updatedTableArr[index],
                                priceType: newValue,
                                effectivefrom: newEffectiveFrom,
                              };
                            
                              setRows(updatedTableArr);
                              setIsDuplicate(isDuplicate);
                            }}
                            onKeyDown={(e) => {
                              const warMsg = "Price Type is required";

                              const currentId = nameObj.priceType + `${index}`;
                              const nextId = nameObj.amount + `${index}`;
                              const prevID = nameObj.activeType + `${index}`;
                              const required = true;
                              handleAutoCompleteKeyDown(
                                e,

                                currentId,
                                nextId,
                                required,
                                warMsg,
                                prevID
                              );
                            }}
                            sx={{
                              width: registrationType === 1 ? "100%" : 140,
                              "& .MuiOutlinedInput-root": {
                                border: "none !important",
                                outline: "none !important",
                                boxShadow: "none !important",
                                "&:hover": {
                                  border: "none !important",
                                  outline: "none !important",
                                  boxShadow: "none !important",
                                },
                                "&.Mui-focused": {
                                  border: "none !important",
                                  outline: "none !important",
                                  boxShadow: "none !important",
                                },
                                "& fieldset": {
                                  border: "none !important",
                                },
                              },
                              "& .MuiOutlinedInput-input": {
                                outline: "none !important",
                                boxShadow: "none !important",
                              },
                              "&.MuiAutocomplete-root": {
                                border: "none !important",
                                outline: "none !important",
                              },
                              "& .MuiInputBase-root": {
                                border: "none !important",
                                boxShadow: "none !important",
                              },
                            }}
                            
                            size="small"
                            renderInput={(params) => (
                              <TextField
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                {...params}
                                InputProps={{
                                  ...params.InputProps,
                                }}
                              />
                            )}
                            renderOption={(props, option) => (
                              <>
                                {option === "Add Price Type" ? (
                                  <MenuItem
                                    value={"addpricetype"}
                                    onClick={(event) => {
                                      event.stopPropagation();
                                      event.preventDefault();
                                      setRowIndex(index);
                                      const updatedTableArr = [...rows];
                                      setUpdatePriceRow(updatedTableArr);
                                      setOpenPriceModal(true);
                                    }}
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      position: "sticky",

                                      top: "0px",
                                      zIndex: 1,
                                      backgroundColor: grey[50],
                                      "&:hover": {
                                        backgroundColor: grey[200],
                                      },
                                    }}
                                  >
                                    <AddBox
                                      fontSize="small"
                                      sx={{
                                        marginRight: "5px",
                                        color: "primary.main",
                                      }}
                                    />
                                    <ListItemText
                                      sx={{ color: "primary.main" }}
                                      primary="Add Price Type"
                                    />
                                  </MenuItem>
                                ) : (
                                  <li {...props}>{option.label}</li>
                                )}
                              </>
                            )}
                          />
                        </TableCell>
                        <TableCell
                          className={
                            (col?.amount == 0 || col?.amount === "") &&
                            isValid === false
                              ? classes?.errorTableCell
                              : ""
                          }
                        >
                          <MoneyTextField
                            value={col?.amount?Number(col?.amount):null}
                            disabled={
                              activeFlag == 0 || params?.view === true
                                ? true
                                : false
                            }
                            min={0}
                            max={9999999999}
                            maxErrorMessage="Maximum 10 digits allowed before decimal."
                            openOnFocus
                            // onClick={moveCursorToEnd}

                            onChange={(num) => {
                              // let value = e?.target.value;

                              // value = value.replace(/,/g, "");
                              let value=num;

                              // if (!/^-?\d*(?:\.\d*)?$/.test(value)) return;
                              // if (!/^-?\d*\.?\d{0,2}$/.test(value)) return;

                              const numericValue = Number(value);
                              const maxLimit = 1000000000;

                              const updatedTableArr = [...rows];
                              const minLimit = Number(
                                updatedTableArr[index]?.discountAmt
                              );

                              if (numericValue > maxLimit) return;
                              if (
                                minLimit > 0 &&
                                updatedTableArr[index]?.DiscountType == 2 &&
                                Number(value) <= minLimit
                              ) {
                                showWarningSnackbar(
                                  "Discount should not be greater than rate applied"
                                );
                                return;
                              }

                              // const regex = /^[0-9]+$/;

                              if (Number(value)>0) {
                                setActiveRow(true);
                                displayTotalAmountBySellingPrice(value, index);
                              } else {
                                displayTotalAmountBySellingPrice(0, index);
                              }
                            }}
                            // onBlur={() => {
                            //   const updatedTableArr = [...rows];
                            //   formatNumbers(
                            //     index,
                            //     "amount",
                            //     updatedTableArr[index]?.amount
                            //   );
                            // }}
                            onKeyDown={(e) => {
                              const warMsg = "Rate is required";

                              const currentId = `${nameObj.amount}${index}`;
                              const nextId = `${nameObj.DiscountType}${index}`;
                              const prevID =
                                // tableType === "Sales"
                                //   ? 
                                  `${nameObj.priceType}${index}`
                                  // : `${nameObj.activeType}${index}`;
                              const required = true;

                              handleTextKeyDown(
                                e,
                                currentId,
                                nextId,
                                required,
                                warMsg,
                                prevID
                              );
                            }}
                            type="text"
                            id={nameObj?.amount + `${index}`}
                            name={nameObj?.amount + `${index}`}
                            label=""
                            variant="outlined"
                            size="small"
                            fullWidth
                            InputProps={{
                              inputProps: {
                                style: {
                                  textAlign: "right",
                                  paddingRight: "0px",
                                },
                                min: 0,
                              },
                            }}
                            onKeyPress={(event) => {
                              if (event?.key === "-" || event?.key === "+") {
                                event.preventDefault();
                              }
                            }}
                            sx={{
                              "& .MuiOutlinedInput-root": {
                              border: "none",
                              outline: "none",
                              boxShadow: "none",
                              "&:hover": {
                                border: "none",
                                outline: "none",
                              },
                              "&.Mui-focused": {
                                border: "none",
                                outline: "none",
                                boxShadow: "none",
                              },
                              "& fieldset": {
                                border: "none !important",
                              },
                            },

                            // Extra safety to remove outline from input itself
                            "& .MuiOutlinedInput-input": {
                              outline: "none",
                            },

                            // Remove global focus-visible ring
                            "&:focus-visible": {
                              outline: "none",
                              boxShadow: "none",
                            },
                              minWidth: 120,
                            }}
                          />
                        </TableCell>

                        <TableCell>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              border: "none",
                              padding: 0,
                              width:"180px"
                            }}
                          >
                            {/* <TextField
                              select
                              openOnFocus
                              value={col?.DiscountType}
                              name={nameObj?.DiscountType + `${index}`}
                              id={nameObj?.DiscountType + `${index}`}
                              size="small"
                              disabled={
                                col?.amount === 0 || params?.view === true
                                  ? true
                                  : false
                              }
                              onChange={(e) => {
                                const value = e?.target.value;
                                setActiveRow(true);
                                displayTotalAmountBySellingDiscountType(
                                  value,
                                  index
                                );
                              }}
                              onKeyDown={(e) => {
                                const warMsg = "";

                                const currentId = `${nameObj.DiscountType}${index}`;
                                const nextId = `${nameObj.DiscountValue}${index}`;
                                const prevID = `${nameObj.amount}${index}`;
                                const required = false;

                                handleTextKeyDown(
                                  e,
                                  currentId,
                                  nextId,
                                  required,
                                  warMsg,
                                  prevID
                                );
                              }}
                              sx={{
                                "& .MuiOutlinedInput-root": {
                              border: "none",
                              outline: "none",
                              boxShadow: "none",
                              "&:hover": {
                                border: "none",
                                outline: "none",
                              },
                              "&.Mui-focused": {
                                border: "none",
                                outline: "none",
                                boxShadow: "none",
                              },
                              "& fieldset": {
                                border: "none !important",
                              },
                            },

                            // Extra safety to remove outline from input itself
                            "& .MuiOutlinedInput-input": {
                              outline: "none",
                            },

                            // Remove global focus-visible ring
                            "&:focus-visible": {
                              outline: "none",
                              boxShadow: "none",
                            },

                                flex: 1,
                                minWidth: 50,
                              }}
                              InputProps={{
                                inputProps: {
                                  style: {
                                    textAlign: "left",
                                    paddingRight: "32px",
                                  },
                                  min: 0,
                                },
                              }}
                            >
                              {DiscountType.map((item, ind) => {
                                return (
                                  <MenuItem
                                    key={item.value}
                                    value={`${item.value}`}
                                  >
                                    <ListItemText
                                      sx={{ margin: "0px" }}
                                      primary={item.label}
                                    />
                                  </MenuItem>
                                );
                              })}
                            </TextField> */}
                            <Autocomplete
                              options={DiscountType}
                              name={nameObj?.DiscountType + `${index}`}
                              id={nameObj?.DiscountType + `${index}`}
                              disableClearable
                              openOnFocus
                              value={DiscountType.find((d) => `${d.value}` === `${col?.DiscountType}`) || null}
                              disabled={col?.amount === 0 || params?.view === true}
                              getOptionLabel={(option) => option.label}
                              onChange={(e, newValue) => {
                                const value = newValue?.value ?? "";
                                displayTotalAmountBySellingDiscountType(value, index);
                              }}
                              onKeyDown={(e) => {
                                const warMsg = "";
                                const currentId = `${nameObj.DiscountType}${index}`;
                                const nextId = `${nameObj.DiscountValue}${index}`;
                                const prevID = `${nameObj.amount}${index}`;
                                const required = false;
                            
                                handleTextKeyDown(e, currentId, nextId, required, warMsg, prevID);
                              }}
                              isOptionEqualToValue={(option, value) => option.value === value.value}
                              sx={{
                                flex: 1,
                                minWidth: 50,
                                "& .MuiInputBase-root": {
                                  height: "32px",
                                  fontSize: "16px",     // ⬆️ Bigger Text
                                  padding: 0,
                                },
                                "& .MuiOutlinedInput-root": {
                                  border: "none",
                                  outline: "none",
                                  boxShadow: "none",
                                  "&:hover": { border: "none" },
                                  "&.Mui-focused": {
                                    border: "none",
                                    outline: "none",
                                    boxShadow: "none",
                                  },
                                  "& fieldset": { border: "none !important" },
                                },
                                "& .MuiOutlinedInput-input": {
                                  padding: "4px 8px !important",
                                  fontSize: "16px",     // ⬆️ Bigger input text
                                  textAlign: "left",
                                },
                              }}
                              renderOption={(props, option) => (
                                <MenuItem {...props} key={option.value} sx={{ fontSize: "14px" }}>
                                  {option.label}
                                </MenuItem>
                              )}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  // autoFocus
                                  size="small"
                                  name={nameObj?.DiscountType + `${index}`}
                            
                                  InputProps={{
                                    ...params.InputProps,
                                    style: { fontSize: "14px" },   // ⬆️ Bigger selected text
                                    inputProps: {
                                      ...params.inputProps,
                                      style: {
                                        fontSize: "14px",         // ⬆️ Bigger typed text
                                        textAlign: "left",
                                        paddingRight: "32px",
                                      },
                                    },
                                  }}
                                />
                              )}
                            />
                            <MoneyTextField
                              key={`${index}-${col?.DiscountType}`}
                              value={col?.DiscountValue?Number(col?.DiscountValue):null}
                              // onClick={moveCursorToEnd}
                              disabled={
                                col?.amount === 0 || params?.view === true
                                  ? true
                                  : false
                              }
                              min={0}
                              max={Number(col?.DiscountType)===1?99.99:Number(col?.amount)-1}
                              maxErrorMessage="Discount should not be greater than rate applied."
                              onChange={(num) => {
                                // let value = e?.target.value;

                                // value = value.replace(/,/g, "");
                                let value = Number(num);

                                // const regex = /^[0-9]+$/;

                                // if (!/^-?\d*(?:\.\d*)?$/.test(value)) return;
                                // if (!/^-?\d*\.?\d{0,2}$/.test(value)) return;

                                const updatedTableArr = [...rows];
                                // const numericValue = parseFloat(value);
                                const maxLimit =
                                  updatedTableArr[index]?.DiscountType == 1
                                    ? 99.999
                                    : Number(updatedTableArr[index]?.amount);

                                if (Number(value) >= maxLimit) {
                                  showWarningSnackbar(
                                    "Discount should not be greater than rate applied"
                                  );
                                  return;
                                }

                                if (Number(value)>0) {
                                  setActiveRow(true);
                                  displayTotalAmountBySellingDiscount(
                                    value,
                                    index
                                  );
                                } else {
                                  displayTotalAmountBySellingDiscount(0, index);
                                }
                              }}
                              // onBlur={() => {
                              //   const updatedTableArr = [...rows];
                              //   formatNumbers(
                              //     index,
                              //     "DiscountValue",
                              //     updatedTableArr[index]?.DiscountValue
                              //   );
                              // }}
                              onKeyDown={(e) => {
                                const warMsg = "";

                                const currentId = `${nameObj.DiscountValue}${index}`;
                                const nextId = `${nameObj.discountAmt}${index}`;
                                const prevID = `${nameObj.DiscountType}${index}`;
                                const required = false;

                                handleTextKeyDown(
                                  e,
                                  currentId,
                                  nextId,
                                  required,
                                  warMsg,
                                  prevID
                                );
                              }}
                              type="text"
                              id={nameObj?.DiscountValue + `${index}`}
                              name={nameObj?.DiscountValue + `${index}`}
                              label=""
                              variant="outlined"
                              size="small"
                              fullWidth
                              InputProps={{
                                inputProps: {
                                  style: {
                                    textAlign: "right",
                                    paddingRight: "0px",
                                  },
                                  min: 0,
                                },
                              }}
                              sx={{
                                "& .MuiOutlinedInput-root": {
                              border: "none",
                              outline: "none",
                              boxShadow: "none",
                              "&:hover": {
                                border: "none",
                                outline: "none",
                              },
                              "&.Mui-focused": {
                                border: "none",
                                outline: "none",
                                boxShadow: "none",
                              },
                              "& fieldset": {
                                border: "none !important",
                              },
                            },

                            // Extra safety to remove outline from input itself
                            "& .MuiOutlinedInput-input": {
                              outline: "none",
                            },

                            // Remove global focus-visible ring
                            "&:focus-visible": {
                              outline: "none",
                              boxShadow: "none",
                            },

                                minWidth: 120,
                                flex: 1,
                              }}
                            />
                          </Box>
                        </TableCell>
                        <TableCell
                          onKeyDown={(e) => {
                            const warMsg = "";

                            const currentId = `${nameObj.discountAmt}${index}`;
                            const nextId = `${nameObj.amtaftdicount}${index}`;
                            const prevID = `${nameObj.DiscountValue}${index}`;
                            const required = false;

                            handleTextKeyDown(
                              e,
                              currentId,
                              nextId,
                              required,
                              warMsg,
                              prevID
                            );
                          }}
                          id={nameObj.discountAmt + `${index}`}
                          tabIndex="0"
                          sx={{ minWidth: 120, outline: "none" }}
                          align="right"
                        >
                          {MoneyFormatv3(col?.discountAmt)}
                        </TableCell>
                        <TableCell
                          onKeyDown={(e) => {
                            let companyType =
                              companyData?.relatedcompanydetailsnew?.[0]
                                ?.registrationtype;
                            const warMsg = "";

                            const currentId = `${nameObj.discountAmt}${index}`;
                            // const nextId =
                            //   registrationType !== 1
                            //     ? companyType == 3
                            //       ? nameObj?.amountIncludingGst + `${index}`
                            //       : nameObj?.gstRate + `${index}`
                            //     : nameObj?.amountIncludingGst + `${index}`;
                                                          const nextId =
  registrationType !== 1
    ? (companyType === 3
      ? (tableType === "Sales"
          ? nameObj.amountIncludingGst + `${index}`
          : nameObj.gstRate + `${index}`
        )
      : nameObj.gstRate + `${index}`)
    : nameObj.amountIncludingGst + `${index}`;
                            const prevID = `${nameObj.discountAmt}${index}`;
                            const required = false;

                            handleTextKeyDown(
                              e,
                              currentId,
                              nextId,
                              required,
                              warMsg,
                              prevID
                            );
                          }}
                          id={nameObj.amtaftdicount + `${index}`}
                          sx={{ minWidth: 120, outline: "none" }}
                          tabIndex="0"
                          align="right"
                        >
                          {MoneyFormatv3(col?.amtaftdicount)}
                        </TableCell>
                        {registrationType !== 1 && (
                          <>
                            <TableCell
                              className={
                                col?.gstRate?.id === "" && isValid === false
                                  ? classes?.errorTableCell
                                  : ""
                              }
                            >
                              <Autocomplete
                                openOnFocus
                                disableClearable
                                autoFocus
                                className={classes.autocomplete}
                                disabled={
                                  col?.amount === 0 ||
                                  params?.view === true ||
                                  (companyType===3 && tableType==="Sales")
                                    ? true
                                    : false
                                }
                                id={`${nameObj.gstRate}${index}`}
                                name={nameObj?.gstRate + `${index}`}
                                value={col?.gstRate}
                                options={GStRates}
                                isOptionEqualToValue={(option, value) =>
                                  option?.value === value?.value
                                }
                                getOptionLabel={(option) => option.rate.trim()}
                                onChange={(event, newValue) => {
                                  if (newValue) {
                                    setActiveRow(true);
                                    displayTotalAmountByGSTRate(
                                      newValue,
                                      index
                                    );
                                  }
                                }}
                                onKeyDown={(e) => {
                                  const cessFlag =
                                    companyData?.relatedcompanydetailsnew?.[0]
                                      ?.gstcompensationcessflag;
                                  const warMsg = "GST Rate is required";

                                  const currentId =
                                    nameObj.gstRate + `${index}`;
                                  const nextId =
                                    cessFlag == 1
                                      ? nameObj.cesstype + `${index}`
                                      : nameObj.amountIncludingGst + `${index}`;
                                  const prevID =
                                    nameObj.amtaftdicount + `${index}`;
                                  const required = true;
                                  handleAutoCompleteKeyDown(
                                    e,

                                    currentId,
                                    nextId,
                                    required,
                                    warMsg,
                                    prevID
                                  );
                                }}
                                sx={{
                                  "& .MuiOutlinedInput-root": {
                              border: "none",
                              outline: "none",
                              boxShadow: "none",
                              "&:hover": {
                                border: "none",
                                outline: "none",
                              },
                              "&.Mui-focused": {
                                border: "none",
                                outline: "none",
                                boxShadow: "none",
                              },
                              "& fieldset": {
                                border: "none !important",
                              },
                            },

                            // Extra safety to remove outline from input itself
                            "& .MuiOutlinedInput-input": {
                              outline: "none",
                            },

                            // Remove global focus-visible ring
                            "&:focus-visible": {
                              outline: "none",
                              boxShadow: "none",
                            },
                                  minWidth: 100,
                                  outline: "none",
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    name="gstRate"
                                    id="gstRate"
                                    label=""
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                  />
                                )}
                              />
                            </TableCell>
                            {(companyData?.relatedcompanydetailsnew?.[0] ==
                            undefined
                              ? companyData
                              : companyData?.relatedcompanydetailsnew?.[0]
                            )?.gstcompensationcessflag === 1 && (
                              <>
                                <TableCell>
                                  {/* <TextField
                                    select
                                    value={col?.cesstype}
                                    id={nameObj.cesstype + `${index}`}
                                    name={nameObj.cesstype + `${index}`}
                                    disabled={
                                      col?.amount === 0 || params?.view === true
                                        ? true
                                        : false
                                    }
                                    size="small"
                                    onChange={(e) => {
                                      const value = e?.target.value;
                                      setActiveRow(true);
                                      displayTotalAmountBySellingCessType(
                                        value,
                                        index
                                      );
                                    }}
                                    onKeyDown={(e) => {
                                      const warMsg = "";

                                      const currentId = `${nameObj.cesstype}${index}`;
                                      const nextId = nameObj?.cess + `${index}`;
                                      const prevID = `${nameObj.gstRate}${index}`;
                                      const required = false;

                                      handleTextKeyDown(
                                        e,
                                        currentId,
                                        nextId,
                                        required,
                                        warMsg,
                                        prevID
                                      );
                                    }}
                                    sx={{
                                      "& .MuiOutlinedInput-root": {
                              border: "none",
                              outline: "none",
                              boxShadow: "none",
                              "&:hover": {
                                border: "none",
                                outline: "none",
                              },
                              "&.Mui-focused": {
                                border: "none",
                                outline: "none",
                                boxShadow: "none",
                              },
                              "& fieldset": {
                                border: "none !important",
                              },
                            },

                            // Extra safety to remove outline from input itself
                            "& .MuiOutlinedInput-input": {
                              outline: "none",
                            },

                            // Remove global focus-visible ring
                            "&:focus-visible": {
                              outline: "none",
                              boxShadow: "none",
                            },
                                      minWidth: 80,
                                    }}
                                    InputProps={{
                                      inputProps: {
                                        style: {
                                          textAlign: "left",
                                          paddingRight: "0px",
                                        },
                                        min: 0,
                                      },
                                    }}
                                  >
                                    {CessTypes.map((item, ind) => {
                                      return (
                                        <MenuItem
                                          key={item.value}
                                          value={`${item.value}`}
                                        >
                                          <ListItemText
                                            sx={{ margin: "0px" }}
                                            primary={item.label}
                                          />
                                        </MenuItem>
                                      );
                                    })}
                                  </TextField> */}
                                   <Autocomplete
                                    options={CessTypes}
                                    disableClearable
                                     id={nameObj.cesstype + `${index}`}
                                     name={nameObj.cesstype + `${index}`}
                                     openOnFocus
                                    autoHighlight
                                    value={CessTypes.find((x) => `${x.value}` === `${col?.cesstype}`) || null}
                                    getOptionLabel={(option) => option.label}
                                    onChange={(e, newValue) => {
                                      const value = newValue?.value ?? "";
                                      displayTotalAmountBySellingCessType(value, index);
                                    }}
                                    onKeyDown={(e) => {
                                      const warMsg = "";
                                      const currentId = `${nameObj.cesstype}${index}`;
                                      const nextId = `${nameObj.cess}${index}`;
                                      const prevID = `${nameObj.gstRate}${index}`;
                                      const required = false;
                                  
                                      handleTextKeyDown(e, currentId, nextId, required, warMsg, prevID);
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        size="small"
                                        inputProps={{
                                          ...params.inputProps,
                                          style: {
                                            padding: "4px 8px",
                                            fontSize: "16px",
                                          },
                                        }}
                                      />
                                    )}
                                    sx={{
                                      minWidth: 130,
                                      flex: 1,
                                  
                                      "& .MuiInputBase-root": {
                                        height: "32px",
                                        paddingRight: "24px !important", // SPACE FOR ARROW
                                        fontSize: "16px",
                                      },
                                  
                                      "& .MuiOutlinedInput-root": {
                                        border: "none !important",
                                        outline: "none !important",
                                        boxShadow: "none !important",
                                        paddingRight: "0px !important",
                                  
                                        "& fieldset": {
                                          border: "none !important",
                                        },
                                        "&:hover fieldset": {
                                          border: "none !important",
                                        },
                                        "&.Mui-focused fieldset": {
                                          border: "none !important",
                                        },
                                      },
                                  
                                      // Keep arrow visible
                                      "& .MuiAutocomplete-endAdornment": {
                                        display: "flex !important",
                                        right: "4px",
                                      },
                                  
                                      "& .MuiSvgIcon-root": {
                                        fontSize: "18px", // arrow size slightly smaller to match your design
                                      },
                                  
                                      "& .MuiAutocomplete-input": {
                                        padding: "4px 8px !important",
                                        fontSize: "16px !important",
                                      },
                                    }}
                                  />
                                </TableCell>
                                <TableCell>
                                  <MoneyTextField
                                    value={col?.cess?Number(col?.cess):null}
                                    // onClick={moveCursorToEnd}
                                    disabled={
                                      col?.amount === 0 || params?.view === true
                                        ? true
                                        : false
                                    }
                                    
                                      min={0}
                                      max={Number(col?.cesstype)===1?100:Number(col?.amtaftdicount)}
                                    maxErrorMessage={
  Number(col?.cesstype) === 1
    ? "Maximum 100% is allowed."
    : "Cess amount should not exceed the taxable amount."
}
                                    onChange={(num) => {
                                      // let value = e?.target.value;

                                      // value = value.replace(/,/g, "");
                                      let value = Number(num);

                                      // const regex = /^[0-9]+$/;

                                      // if (!/^-?\d*(?:\.\d*)?$/.test(value))
                                      //   return;
                                      // if (!/^-?\d*\.?\d{0,2}$/.test(value))
                                      //   return;

                                      // const numericValue = parseFloat(value);

                                      const updatedTableArr = [...rows];
                                      const maxLimit =
                                        updatedTableArr[index]?.cesstype === 1
                                          ? 100
                                          : Number(
                                              updatedTableArr[index]?.amount
                                            );

                                      if (Number(value) > maxLimit) return;

                                      if (Number(value)>0) {
                                        setActiveRow(true);
                                        displayTotalAmountBySellingCess(
                                          value,
                                          index
                                        );
                                      } else {
                                        displayTotalAmountBySellingCess(
                                          0,
                                          index
                                        );
                                      }
                                    }}
                                    // onBlur={() => {
                                    //   const updatedTableArr = [...rows];
                                    //   formatNumbers(
                                    //     index,
                                    //     "cess",
                                    //     updatedTableArr[index]?.cess
                                    //   );
                                    // }}
                                    onKeyDown={(e) => {
                                      const warMsg = "";

                                      const currentId = `${nameObj.cess}${index}`;
                                      const nextId =
                                        nameObj?.amountIncludingGst +
                                        `${index}`;
                                      const prevID = `${nameObj.cesstype}${index}`;
                                      const required = false;

                                      handleTextKeyDown(
                                        e,
                                        currentId,
                                        nextId,
                                        required,
                                        warMsg,
                                        prevID
                                      );
                                    }}
                                    type="text"
                                    id={nameObj.cess + `${index}`}
                                    name={nameObj.cess + `${index}`}
                                    label=""
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    InputProps={{
                                      inputProps: {
                                        style: {
                                          textAlign: "right",
                                          paddingRight: "0px",
                                        },
                                        min: 0,
                                      },
                                    }}
                                    onKeyPress={(event) => {
                                      if (
                                        event?.key === "-" ||
                                        event?.key === "+"
                                      ) {
                                        event.preventDefault();
                                      }
                                    }}
                                    sx={{
                                      "& .MuiOutlinedInput-root": {
                              border: "none",
                              outline: "none",
                              boxShadow: "none",
                              "&:hover": {
                                border: "none",
                                outline: "none",
                              },
                              "&.Mui-focused": {
                                border: "none",
                                outline: "none",
                                boxShadow: "none",
                              },
                              "& fieldset": {
                                border: "none !important",
                              },
                            },

                            // Extra safety to remove outline from input itself
                            "& .MuiOutlinedInput-input": {
                              outline: "none",
                            },

                            // Remove global focus-visible ring
                            "&:focus-visible": {
                              outline: "none",
                              boxShadow: "none",
                            },
                                      minWidth: 100,
                                    }}
                                  />
                                </TableCell>
                              </>
                            )}
                          </>
                        )}

                        <TableCell
                          onKeyDown={(e) => {
                            const cessFlag =
                              companyData?.relatedcompanydetailsnew?.[0]
                                ?.gstcompensationcessflag === 1;
                            let companyType =
                              companyData?.relatedcompanydetailsnew?.[0]
                                ?.registrationtype;
                            const warMsg = "";

                            const currentId = `${nameObj.amountIncludingGst}${index}`;
                            const nextId = nameObj?.effectivefrom + `${index}`;
                            const prevID =
                              registrationType === 1
                                ? `${nameObj.amtaftdicount}${index}`
                                : cessFlag === 1
                                ? `${nameObj.cess}${index}`
                                : `${nameObj.gstRate}${index}`;
                            const required = false;

                            handleTextKeyDown(
                              e,
                              currentId,
                              nextId,
                              required,
                              warMsg,
                              prevID
                            );
                          }}
                          tabIndex="0"
                          id={nameObj.amountIncludingGst + `${index}`}
                          sx={{ minWidth: 120, outline: "none" }}
                          align="right"
                        >
                          {MoneyFormatv3(col?.amountIncludingGst)}
                        </TableCell>
                        <TableCell
                         className={ (moment(col.effectivefrom, ["DD-MM-YYYY", "YYYY-MM-DD"], true) > moment(col.effectiveto, ["DD-MM-YYYY", "YYYY-MM-DD"], true)) &&
                                                     isValid === false
                                                        ? classes?.errorTableCell
                                                        : ""
                                                    }>
                          <TextField
                            // onFocus={(e) => e?.target?.showPicker()}
                            value={col?.effectivefrom}
                            disabled={
                              col?.amount === 0 || params?.view === true
                                ? true
                                : false
                            }
                            onChange={(e) => {
                                                            const value = e?.target.value;
                                                            const updatedTableArr = [...rows];
                                                            const currentRow = updatedTableArr[index];
                                                          
                                                            // Allow clearing the input (backspace/delete)
                                                            if (value === "") {
                                                              updatedTableArr[index] = {
                                                                ...currentRow,
                                                                effectivefrom: "",
                                                              };
                                                              setRows(updatedTableArr);
                                                              return;
                                                            }
                                                          
                                                            const formattedValue = moment(value, ["DD-MM-YYYY", "YYYY-MM-DD"], true);
                                                            const currentFromDate = moment(value, ["DD-MM-YYYY", "YYYY-MM-DD"], true);
                                                            const currentToDate = moment(currentRow.effectiveto, ["DD-MM-YYYY", "YYYY-MM-DD"], true);
                                                          
                                                            // if (
                                                            //   currentRow.effectiveto &&
                                                            //   currentRow.effectiveto !== 0 &&
                                                            //   currentFromDate.isValid() &&
                                                            //   currentToDate.isValid() &&
                                                            //   !currentFromDate.isBefore(currentToDate) &&
                                                            //   !currentFromDate.isSame(currentToDate, "day")
                                                            // ) {
                                                            //   showWarningSnackbar("Effective From date must be earlier than Effective To date.");
                                                            //   return;
                                                            // }
                                                          
                                                            let isDuplicate = false;
                                                            let invalidDate = false;
                                                          
                                                            updatedTableArr.forEach((ele, ind) => {
                                                              if (
                                                                ind !== index &&
                                                                ele.priceType?.label?.toLowerCase().trim() === currentRow?.priceType?.label?.toLowerCase().trim()
                                                              ) {
                                                                isDuplicate = true;
                                                              }
                                                            });
                                                          
                                                            updatedTableArr.forEach((ele, i) => {
                                                              if (i !== index && ele?.priceType?.label === currentRow?.priceType?.label) {
                                                                const effectiveFrom = moment(ele.effectivefrom);
                                                                const effectiveTo = moment(ele.effectiveto);
                                                                const currentEffectiveTo = moment(currentRow?.effectiveto);
                                                          
                                                                if (
                                                                  currentEffectiveTo.isBetween(effectiveFrom, effectiveTo, null, "[]") ||
                                                                  currentEffectiveTo.isSame(effectiveFrom, "day") ||
                                                                  currentEffectiveTo.isSame(effectiveTo, "day") ||
                                                                  currentFromDate.isBetween(effectiveFrom, effectiveTo, null, "[]") ||
                                                                  currentFromDate.isSame(effectiveFrom, "day") ||
                                                                  currentFromDate.isSame(effectiveTo, "day") ||
                                                                  effectiveFrom.isBetween(currentFromDate, currentEffectiveTo, null, "[]") ||
                                                                  effectiveTo.isBetween(currentFromDate, currentEffectiveTo, null, "[]")
                                                                ) {
                                                                  invalidDate = true;
                                                                }
                                                              }
                                                            });
                                                          
                                                            if (invalidDate 
                                                              // && tableType === "Sales"
                                                            ) {
                                                              showWarningSnackbar("Price Type already added with this date range");
                                                          
                                                              const element = document.getElementById(nameObj?.priceType + `${index}`);
                                                              element?.focus();
                                                          
                                                              updatedTableArr[index] = {
                                                                ...currentRow,
                                                                priceType: { label: "", value: 0 },
                                                              };
                                                            } else if (!isNaN(new Date(value)) && formattedValue.isValid()) {
                                                              updatedTableArr[index] = {
                                                                ...currentRow,
                                                                effectivefrom: value,
                                                              };
                                                              setRowIndex(index);
                                                            }
                                                          
                                                            setRows(updatedTableArr);
                                                          }}
                            onKeyDown={(e) => {
                              const warMsg = "";

                              const currentId = `${nameObj.effectivefrom}${index}`;
                              const nextId = nameObj?.effectiveto + `${index}`;
                              const prevID = `${nameObj.amountIncludingGst}${index}`;
                              const required = false;

                              handleTextKeyDown(
                                e,
                                currentId,
                                nextId,
                                required,
                                warMsg,
                                prevID
                              );
                            }}
                            type="date"
                            id={nameObj?.effectivefrom + `${index}`}
                            name={nameObj?.effectivefrom + `${index}`}
                            label=""
                            variant="outlined"
                            size="small"
                            fullWidth
                               InputProps={{
                                inputProps: {
                                  style: {
                                    textAlign: "left",
                                    paddingRight: "0px",
                                  },
                                },
                              }}
                             
                            sx={{
                              "& .MuiOutlinedInput-root": {
                              border: "none",
                              outline: "none",
                              boxShadow: "none",
                              "&:hover": {
                                border: "none",
                                outline: "none",
                              },
                              "&.Mui-focused": {
                                border: "none",
                                outline: "none",
                                boxShadow: "none",
                              },
                              "& fieldset": {
                                border: "none !important",
                              },
                            },

                            // Extra safety to remove outline from input itself
                            "& .MuiOutlinedInput-input": {
                              outline: "none",
                            },

                            // Remove global focus-visible ring
                            "&:focus-visible": {
                              outline: "none",
                              boxShadow: "none",
                            },
                            }}
                          />
                        </TableCell>
                        <TableCell
                          className={ (moment(col.effectiveto, ["DD-MM-YYYY", "YYYY-MM-DD"], true) < moment(col.effectivefrom, ["DD-MM-YYYY", "YYYY-MM-DD"], true)) &&
                                                      isValid === false
                                                         ? classes?.errorTableCell
                                                         : ""
                                                     }>
                          <TextField
                            inputRef={textFieldRef}
                            onFocus={(e) => {
                              // e?.target?.showPicker();
                              scrollToField();
                            }}
                            value={col?.effectiveto}
                            disabled={
                              col?.amount === 0 || params?.view === true
                                ? true
                                : false
                            }
                            onChange={(e) => {
                              const value = e?.target.value;
                              const formattedValue = moment(
                                value,
                                ["DD-MM-YYYY", "YYYY-MM-DD"],
                                true
                              );
                              setActiveRow(true);
                              let isDuplicate = false;
                              let invalidDate = false;
                              const updatedTableArr = [...rows];
                              const currentToDate = moment(value);

                              // Duplicate check for priceType
                              updatedTableArr.map((ele, ind) => {
                                if (
                                  ind !== index &&
                                  ele.priceType?.label?.toLowerCase().trim() ===
                                    updatedTableArr[index]?.priceType?.label
                                      ?.toLowerCase()
                                      .trim()
                                ) {
                                  isDuplicate = true;
                                }
                              });

                              // Date validation for overlapping ranges
                              updatedTableArr.map((ele, i) => {
                                if (i !== index  && ele?.priceType?.label==updatedTableArr[index]?.priceType?.label) {
                                  const effectiveFrom = moment(
                                    ele.effectivefrom
                                  );
                                  const effectiveTo = moment(ele.effectiveto);
                                  const currentDateFrom = moment(
                                    updatedTableArr[index]?.effectivefrom
                                  );
                                  const currentDateTo = moment(value);

                                  if (
                                    currentDateFrom.isBetween(
                                      effectiveFrom,
                                      effectiveTo,
                                      null,
                                      "[]"
                                    ) ||
                                    currentDateTo.isBetween(
                                      effectiveFrom,
                                      effectiveTo,
                                      null,
                                      "[]"
                                    ) ||
                                    effectiveFrom.isBetween(
                                      currentDateFrom,
                                      currentDateTo,
                                      null,
                                      "[]"
                                    ) ||
                                    effectiveTo.isBetween(
                                      currentDateFrom,
                                      currentDateTo,
                                      null,
                                      "[]"
                                    ) ||
                                    currentDateFrom.isSame(
                                      effectiveFrom,
                                      "day"
                                    ) ||
                                    currentDateFrom.isSame(
                                      effectiveTo,
                                      "day"
                                    ) ||
                                    currentDateTo.isSame(
                                      effectiveFrom,
                                      "day"
                                    ) ||
                                    currentDateTo.isSame(effectiveTo, "day")
                                  ) {
                                    invalidDate = true;
                                  }
                                }
                              });

                              // Check for duplicate priceType with invalid date range
                              if (
                                // isDuplicate &&
                                invalidDate 
                                // &&
                                // tableType === "Sales"
                              ) {
                                showWarningSnackbar(
                                  "Price Type already added with this date range"
                                );

                                const element = document.getElementById(
                                  nameObj?.priceType + `${index}`
                                );
                                element?.focus();

                                updatedTableArr[index] = {
                                  ...updatedTableArr[index],
                                  priceType: { label: "", value: 0 },
                                };
                              } else if (
                                !isNaN(new Date(value)) &&
                                formattedValue.isValid()
                              ) {
                                // Update the effectiveto field if the date is valid
                                updatedTableArr[index] = {
                                  ...updatedTableArr[index],
                                  effectiveto: value,
                                };

                                setRowIndex(index);
                              }

                              setRows(updatedTableArr);
                            }}
                            type="date"
                            id={nameObj?.effectiveto + `${index}`}
                            name={nameObj?.effectiveto + `${index}`}
                            label=""
                            variant="outlined"
                            size="small"
                            fullWidth
                                                  InputProps={{
                               inputProps: {
                                 style: { textAlign: "left", paddingRight: "0px" },
                                 min: col?.effectivefrom,
                               },
                               endAdornment: col?.effectiveto ? (
                                 <InputAdornment position="end">
                                   <IconButton
                                     size="small"
                                    //  onClick={() => {
                                    //    const updatedTableArr = [...rows];
                                    //    updatedTableArr[index] = {
                                    //      ...updatedTableArr[index],
                                    //      effectiveto: "",
                                    //    };
                                    //      setRowIndex(index);
                                    //    setRows(updatedTableArr);
                                    //  }}
                                    onClick={()=>{
                                      handleCloseEffectiveTo(index);
                                    }}
                                   >
                                     <Clear fontSize="small" />
                                   </IconButton>
                                 </InputAdornment>
                               ) : null,
                             }}
                            sx={{
                              "& .MuiOutlinedInput-root": {
                              border: "none",
                              outline: "none",
                              boxShadow: "none",
                              "&:hover": {
                                border: "none",
                                outline: "none",
                              },
                              "&.Mui-focused": {
                                border: "none",
                                outline: "none",
                                boxShadow: "none",
                              },
                              "& fieldset": {
                                border: "none !important",
                              },
                            },

                            // Extra safety to remove outline from input itself
                            "& .MuiOutlinedInput-input": {
                              outline: "none",
                            },

                            // Remove global focus-visible ring
                            "&:focus-visible": {
                              outline: "none",
                              boxShadow: "none",
                            },
                              // minWidth: 120,
                            }}
                            onKeyDown={(e) => {
                              if (e.key === "Tab" && e.shiftKey) {
                                e.preventDefault();
                                e.stopPropagation();
                                const prevElement = document.getElementById(
                                  nameObj.effectivefrom + `${index}`
                                );
                                prevElement?.focus();
                                return;
                              }
                              if (
                                e.key === "Enter" ||
                                (e.key === "Tab" && !e.shiftKey)
                              ) {
                                e.preventDefault();
                                e.stopPropagation();
                                const updatedTableArr = [...rows];
                                saveChangesInRows(index);
                              }
                            }}
                          />
                        </TableCell>
                        {params?.view !== true && (
                          <TableCell
                            align="right"
                            className={classes.stickyCell}
                            id="Action"
                            sx={{ backgroundColor: "#FFF",  position: "sticky",
                            right: 0 ,

                            zIndex: 1}}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              {/* {window.innerWidth <= 768 && (
                                <IconButton
                                  disableRipple
                                  disabled={
                                    editedRow.amount === 0 ? true : false
                                  }
                                  aria-label="delete"
                                  sx={{
                                    margin: "0px 2px",
                                    padding: "5px",
                                    backgroundColor: "#83ff7b7a",
                                    outline: "none",
                                  }}
                                  onClick={() => {
                                    saveChangesInRows(index);
                                  }}
                                >
                                  <DoneIcon
                                    sx={{
                                      fontSize: "18px",
                                      color: "#34994f",
                                    }}
                                  />
                                </IconButton>
                              )} */}

                              <IconButton
                                tabIndex="0"
                                id="Action"
                                disableRipple
                                aria-label="delete"
                                sx={{
                                  margin: "0px 2px",
                                  padding: "5px",
                                  backgroundColor: "#fbc7c7",
                                }}
                                onClick={() => {
                                  if (col?.amount === 0) {
                                    closeChangesInRows(index);
                                  } else {
                                    setRowIndex(index);
                                    setDeleteEntriesModal(true);
                                  }

                                  setEditFlag(false);
                                }}
                              >
                                <CloseIcon
                                  sx={{
                                    fontSize: "18px",
                                    color: "#eb6a6a",
                                  }}
                                />
                              </IconButton>
                            </Box>
                          </TableCell>
                        )}
                      </TableRow>
                    );
                  })
                ) : (
                  <TableRow className={classes.table} sx={{ height: "40px" }}>
                    <TableCell
                      align="center"
                      colSpan={
                        registrationType !== 1
                          ? (companyData?.relatedcompanydetailsnew?.[0] ==
                            undefined
                              ? companyData
                              : companyData?.relatedcompanydetailsnew?.[0]
                            )?.gstcompensationcessflag === 1
                            ? 16
                            : 14
                          : 13
                      }
                    >
                      No Data Found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </>

            {params?.view !== true && activeFlag == 1 && (
              <TableRow className={classes.table}>
                <TableCell
                  colSpan={
                    registrationType !== 1
                      ? (companyData?.relatedcompanydetailsnew?.[0] == undefined
                          ? companyData
                          : companyData?.relatedcompanydetailsnew?.[0]
                        )?.gstcompensationcessflag === 1
                        ? 16
                        : 14
                      : 13
                  }
                >
                  <Button
                    disableElevation
                    disableRipple
                    size="small"
                    variant="text"
                    startIcon={<AddBox />}
                    sx={{
                      fontSize: "14px",
                    }}
                    disabled={params?.view === true ? true : false}
                    onClick={() => {
                      // addNewLine();
                      saveChangesInRows("");
                    }}
                  >
                    Add New Line
                  </Button>
                </TableCell>
              </TableRow>
            )}
          </Table>
        </TableContainer>
        <DeleteEntries
          open={deleteEntriesModal}
          setEntryRows={setRows}
          setOpen={setDeleteEntriesModal}
          setsuccessSnakbar={setsuccessSnakbar}
          setSnakbarTex={showSuccessSnackbar}
          entryRows={rows}
          entryInd={rowIndex}
          TableType={"PriceTable"}
          setDeletedRows={setDeletedRows}
        />
        <CreatePriceType
          open={openPriceModal}
          setOpen={setOpenPriceModal}
          setPriceTypeArr={setPriceTypeArr}
          priceTypeID={priceTypeID}
          setPriceTypeID={setPriceTypeID}
          updatePriceRow={updatePriceRow}
          rowIndex={rowIndex}
          setUpdatedRows={setRows}
          amountRows={rows}
          tableType={tableType === "Sales"?1:2}
        />
      </Paper>
    </>
  );
}

export default NewUpdatePriceTable;
